if (!customElements.get("utility-bar")) {
    class UtilityBar extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.menu = this.querySelector(".utility-menu");
            this.initializeMobileMenu();

            // close localization
            window.addEventListener('scroll', () => {
                PubSub.publish(PubSub.events.utilityBarScrolled, {
                    data: {
                        type: 'utility-bar'
                    }
                });
            });

            this.updateMainMargin();
            this.updateTopPosition();
            window.addEventListener('resize', this.updateTopPosition.bind(this));

            this.themeEditorUpdateUnSubscriber = PubSub.subscribe(PubSub.events.themeEditorUpdate, this.refreshSection.bind(this));
        }

        disconnectedCallback(){
            if(this.themeEditorUpdateUnSubscriber){
                this.themeEditorUpdateUnSubscriber();
            }
        }

        refreshSection(){
            setTimeout(() => {
                this.updateTopPosition();
                this.updateMainMargin();
            }, 100);
        }

        updateMainMargin(){
            const height = this.offsetHeight;
            const main = document.querySelector('main');
            if(!main) return;

            main.style.setProperty('--utility-bar-gap', `${height}px`);
        }

        initializeMobileMenu() {
            if (!this.menu) return;
            this.menuList = this.menu.querySelectorAll("li[data-type=link], li[data-type=social]");

            const mobileDrawer = document.getElementById('mobile-menu-drawer');
            if(!mobileDrawer) return;

            if (this.menuList.length > 0) {
                const mobileDrawerMenu = mobileDrawer.querySelector('.menu--drawer[data-link-handle="-1"]');
                if(!mobileDrawerMenu) return;

                this.menuList.forEach((item, index) => {
                    const liElem = document.createElement('li');
                    liElem.classList.add('w-full', 'p-7', 'cursor-pointer', 'z-10', 'relative', 'menu-item--utility');
                    liElem.classList.add(`${this.dataset.colorScheme}`);
                    if(index === 0){
                        liElem.classList.add('menu-item--utility-first');
                    }
                    if(index == this.menuList.length - 1){
                        liElem.classList.add('menu-item--utility-last');
                    }
                    liElem.innerHTML = item.innerHTML;
                    mobileDrawerMenu.appendChild(liElem);
                });
            }
        }

        updateTopPosition(){
            const sectionHeaders = Array.from(document.querySelectorAll('.section-header'));
            let topPosition = 0;
            sectionHeaders.some(item => {
                const headerElement = item.querySelector(".header-element");
                const style = getComputedStyle(headerElement);

                if(headerElement === this){
                    return true;
                }else{
                    topPosition = topPosition + headerElement.offsetHeight + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
                }
            });

            this.style.setProperty('--top', `${topPosition}px`);
        }
    }

    customElements.define("utility-bar", UtilityBar);
}
